import { createContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in on page load
  useEffect(() => {
    const checkLoggedIn = async () => {
      if (localStorage.getItem('userInfo')) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        setUser(userInfo);
      }
      setLoading(false);
    };

    checkLoggedIn();
  }, []);

  // Login user
  const login = async (username, password) => {
    try {
      console.log('Attempting login with username:', username);
      
      // Make sure we're sending the data in the correct format
      const requestData = {
        username: username.trim(),
        password: password.trim()
      };
      
      console.log('Sending login request to:', '/api/users/login');
      const { data } = await axios.post('/api/users/login', requestData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Store user info in localStorage and state
      localStorage.setItem('userInfo', JSON.stringify(data));
      setUser(data);
      console.log('Login successful:', data);
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      
      return {
        success: false,
        message: error.response?.data?.message || 'Invalid credentials. Please check your username and password.',
      };
    }
  };

  // Logout user
  const logout = () => {
    localStorage.removeItem('userInfo');
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;